/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Col, Label, Alert,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { post } from '../../helpers/api_helper';

function CompatibilityForm(props) {
  const { actionUrl, entity } = props;

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post(actionUrl, values);
      setErrorMessage(null);

      toastr.success(`Entity ID ${result.id} saved`, 'Success');
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    type: Yup
      .string()
      .required(props.t('Type is required')),
    source: Yup
      .string()
      .required(props.t('Brand is Required')),
    identifier: Yup
      .string()
      .required(props.t('Model is Required')),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const options = [
    { value: 'Retail Product', label: 'Retail Product' },
    { value: 'Display Panel', label: 'Display Panel' },
    { value: 'Vending Machine', label: 'Vending Machine' },
    { value: 'Arcade Game', label: 'Arcade Game' },
    { value: 'Slot Machine', label: 'Slot Machine' },
  ];

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, values, setFieldValue,
        }) => (
          <Form className="mt-3" id="ItemEditForm" autoComplete="off">
            <div className="row mt-4 mb-4">
              <Label
                for="type"
                className="col-sm-3 col-form-label"
              >
                {props.t('Type')}
              </Label>
              <Col sm={9}>
                <Field className="form-control" name="type" as="select">
                  {options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="type"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="source"
                className="col-sm-3 col-form-label"
              >
                {props.t('Brand')}
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.brand && touched.brand ? 'is-invalid' : '')}`}
                  id="brand"
                  name="brand"
                />
                <ErrorMessage
                  name="brand"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="model"
                className="col-sm-3 col-form-label"
              >
                {props.t('Model')}
              </Label>
              <Col sm={9}>
                <Field
                  type="text"
                  className={`form-control ${(errors.model && touched.model ? 'is-invalid' : '')}`}
                  id="model"
                  name="model"
                />
                <ErrorMessage
                  name="model"
                  component="div"
                  className="invalid-feedback"
                />
              </Col>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

CompatibilityForm.defaultProps = {
  entity: {
    type: '',
    brand: '',
    model: '',
  },
  onSuccess: () => {},
};

CompatibilityForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(CompatibilityForm));
